import { ITransaction } from ".";
import { Box, Text, Flex, Divider, useMantineTheme } from "@mantine/core";
import { TbArrowsRightLeft } from "react-icons/tb";
import { formatter } from "src/utils/constants";
import { formatDate } from "src/utils/dateHelper";
import { MdOutlineStickyNote2 } from "react-icons/md";

type IProps = {
  detail: ITransaction[0];
};

type IProduct = {
  product: { id: string };
  count: number;
};

export default function DetailModal({ detail }: IProps) {
  const theme = useMantineTheme();
  const { amount, createdDate, agreement, shoppingCart, package: pkg } = detail;
  const products: IProduct[] =
    shoppingCart?.products && JSON.parse(shoppingCart.products);
  let headingColor = "#474747";

  return (
    <>
      <Box>
        <Flex gap={"md"}>
          <Flex
            sx={{
              background: "#B1B1B1",
              padding: 5,
              borderRadius: 5,
              minWidth: 39,
              maxHeight: 41,
              minHeight: 41,
            }}
            align={"center"}
            justify={"center"}
            mt={5}
          >
            <TbArrowsRightLeft size={15} color="white" />
          </Flex>

          <Flex direction={"column"} gap={"sm"}>
            <Box>
              <Text size={14} color={headingColor}>
                Amount
              </Text>
              <Text fw={500}>{formatter.format(amount)}</Text>
            </Box>

            <Box>
              <Text size={14} color={headingColor}>
                From
              </Text>
              <Text fw={500}> - </Text>
            </Box>

            <Box>
              <Text size={14} color={headingColor}>
                Date
              </Text>
              <Text fw={500}>{formatDate(createdDate).format1}</Text>
            </Box>
          </Flex>
        </Flex>

        <Divider sx={{ margin: "18px 0", borderTopWidth: 2 }} />

        <Text size={14} fw={600} color="#707072">
          Transaction Details
        </Text>

        <Flex gap={"md"} mt={"sm"}>
          <Flex
            sx={{
              background: "#B1B1B1",
              padding: 5,
              borderRadius: 5,
              minWidth: 40,
              maxHeight: 40,
              minHeight: 40,
            }}
            align={"center"}
            justify={"center"}
            mt={5}
          >
            <MdOutlineStickyNote2 size={18} color="white" />
          </Flex>

          <Box>
            <Text size={14} fw={600} color={headingColor}>
              Description
            </Text>
            <Flex direction={"column"} gap={"xs"}>
              {!!agreement && (
                <Box>
                  <Text size={14} color={headingColor}>
                    Agreement
                  </Text>
                  <Text fw={500}>{agreement.name}</Text>
                </Box>
              )}

              {!!pkg && (
                <Box>
                  <Text size={14} color={headingColor}>
                    Package
                  </Text>
                  <Text fw={500}>{pkg.name}</Text>
                </Box>
              )}
              {!!products && (
                <Box>
                  <Text size={14} color={headingColor}>
                    Shopping Cart
                  </Text>
                  {products.map((p) => (
                    <Flex
                      key={p.product.id}
                      align={"center"}
                      justify={"center"}
                    >
                      <Text size={11}>{p.product.id}</Text>
                      <Text size={14}>{` - ` + p.count}</Text>
                    </Flex>
                  ))}
                </Box>
              )}
            </Flex>
          </Box>
        </Flex>
      </Box>
    </>
  );
}
